import loadable from "@loadable/component";
import { useSelector } from "react-redux";

import Ad from "../../../../../app/components/Ad/component";

import { concatSubjects } from "../../../../utils/dataTransform/ContentItem/library";

const Comments = loadable(
    () => import("../../../../../app/components/Comments/component.js"),
    { ssr: false }
);
const CommentsAndAd = () => {
    const content = useSelector((state) => state.detail.content);
    const { contentId } = useSelector((state) => state.app);

    if (!content?.displayComments) return null;
    return (
        <div className="commentsWrapper withSidebar">
            <div className="withFlex">
                <div className="detailMainCol">
                    {<Comments storyId={content.id} />}
                </div>
            </div>
            <div className="withFlex">
                <div className="detailSideRail" data-testid="detailSideRail">
                    <div className="stickyContainer stickyRailAd">
                        <Ad
                            type="bigbox-sticky"
                            targeting={{
                                type: "ocelot",
                                contentId: contentId,
                                rmtype: "bigboxfixed",
                                subject: concatSubjects(content.subject),
                                gs_categories: content.gs_categories,
                                gs_keywords: content.gs_keywords,
                                plc: "comments",
                            }}
                            responsive
                            lazy={true}
                            exclusions={content.adExclusions}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommentsAndAd;
